import { gsap } from 'gsap'
import { onMount, onDestroy } from '@/modules/_'

export default function (element: HTMLElement, dataset: DOMStringMap) {
  const image = element.querySelector('.home_news_img img') as HTMLImageElement
  const text = element.querySelector('.home_news_snippet') as HTMLImageElement

  if (!image) return

  let tlIn: gsap.core.Timeline | null = null
  let tlOut: gsap.core.Timeline | null = null

  const easeOutQuart = 'cubic-bezier(0.165, 0.84, 0.44, 1)'
  const easeInOutQuad = 'cubic-bezier(0.45, 0, 0.55, 1)'

  const createHoverInTimeline = () => {
    return gsap
      .timeline({ paused: true })
      .to(
        element,
        {
          scale: 1.01,
          backgroundColor: '#c0beaf',
          boxShadow: '0 8px 16px rgba(0, 0, 0, 0.06)',
          duration: 0.6,
          ease: easeOutQuart,
        },
        0
      )
      .to(
        text,
        {
          color: '#2d2e30',
          duration: 0.6,
          ease: easeOutQuart,
        },
        0
      )
      .to(
        image,
        {
          scale: 1.03,
          duration: 0.7,
          ease: easeOutQuart,
        },
        0
      )
  }

  const createHoverOutTimeline = () => {
    return gsap
      .timeline({ paused: true })
      .to(
        element,
        {
          scale: 1,
          backgroundColor: '#f0eddd',
          boxShadow: '0 0px 0px rgba(0, 0, 0, 0)',
          duration: 0.6,
          ease: easeOutQuart,
        },
        0
      )
      .to(
        text,
        {
          color: '#666662',
          duration: 0.6,
          ease: easeOutQuart,
        },
        0
      )
      .to(
        image,
        {
          scale: 1,
          duration: 0.6,
          ease: easeOutQuart,
        },
        0
      )
  }

  const handleMouseEnter = () => {
    if (tlOut) tlOut.kill()
    if (!tlIn) tlIn = createHoverInTimeline()
    tlIn.restart()
  }

  const handleMouseLeave = () => {
    if (tlIn) tlIn.kill()
    if (!tlOut) tlOut = createHoverOutTimeline()
    tlOut.restart()
  }

  onMount(() => {
    gsap.set(element, {
      backgroundColor: '#f0eddd',
    })

    // Create GSAP matchMedia instance
    const mm = gsap.matchMedia()

    // Only enable hover on devices with hover capability and fine pointer (mouse/trackpad)
    mm.add('(hover: hover) and (pointer: fine)', () => {
      element.addEventListener('mouseenter', handleMouseEnter)
      element.addEventListener('mouseleave', handleMouseLeave)

      // Cleanup function when media query stops matching
      return () => {
        element.removeEventListener('mouseenter', handleMouseEnter)
        element.removeEventListener('mouseleave', handleMouseLeave)
      }
    })
  })

  onDestroy(() => {
    element.removeEventListener('mouseenter', handleMouseEnter)
    element.removeEventListener('mouseleave', handleMouseLeave)
    tlIn?.kill()
    tlOut?.kill()
  })
}
